import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LineChart from '../../components/LineChart';
import MainContainer from '../../layout/MainContainer';
import { useLazyGetGraphsDataQuery } from '../../service/dashboard';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#204e33' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Analytics = () => {
  const navigate = useNavigate();
  const [getData] = useLazyGetGraphsDataQuery();
  const [graphData, setGraphData] = useState<any>();
  const [filter, setFilter] = useState<string>('weekly');

  const fetchFunc = async () => {
    try {
      const res = await getData({ filter: filter }).unwrap();
      if (res?.statusCode === 200) {
        setGraphData(res?.data);
      }
    } catch (error: any) {}
  };

  const graphUsersData = {
    labels:
      graphData?.totalUserGraph?.userData?.length !== 0
        ? graphData?.totalUserGraph?.userData?.map((item: any) => item.name)
        : [],
    datasets: [
      {
        label: 'Total Users',
        data:
          graphData?.totalUserGraph?.userData?.length !== 0
            ? graphData?.totalUserGraph?.userData?.map((item: any) => item.count)
            : [],
        borderColor: '#ed5f00',
        backgroundColor: '#ed5f00',
        color: '#FFFFF',
      },
    ],
  };

  const graphPerformance = {
    labels:
      graphData?.totalAddsGraph?.userData?.length !== 0
        ? graphData?.totalAddsGraph?.userData?.map((item: any) => item.name)
        : [],
    datasets: [
      {
        label: 'Total Users',
        data:
          graphData?.totalAddsGraph?.userData?.length !== 0
            ? graphData?.totalAddsGraph?.userData?.map((item: any) => item.count)
            : [],
        borderColor: '#ed5f00',
        backgroundColor: '#ed5f00',
        color: '#FFFFF',
      },
    ],
  };

  const graphOrderData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Users',
        data: ['10', '20', '25', '15', '50', '10', '20', '25', '15', '50', '20', '25'],
        borderColor: '#ed5f00',
        backgroundColor: '#ed5f00',
        color: '#FFFFF',
      },
    ],
  };
  const graphDealerData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Ads',
        data: ['10', '20', '25', '15', '50', '10', '20', '25', '15', '50', '20', '25'],
        borderColor: '#ed5f00',
        backgroundColor: '#ed5f00',
        color: '#FFFFF',
      },
    ],
  };
  const graphStoreData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Transaction and Payment',
        data: ['10', '20', '25', '15', '50', '10', '20', '25', '15', '50', '20', '25'],
        borderColor: '#ed5f00',
        backgroundColor: '#ed5f00',
        color: '#FFFFF',
      },
    ],
  };

  useEffect(() => {
    fetchFunc();
  }, [filter]);

  return (
    <MainContainer>
      <div className="main_title analytics">
        <h1>Analytics</h1>
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
        </select>
      </div>

      <div className="grid_sc gap_m ">
        <Item className="cards" style={{ borderRadius: '15px' }}>
          <div className="analytics">
            <h2 className="mn_hdng">Total Users</h2>
          </div>
          <LineChart data={graphUsersData} />
        </Item>
        <Item className="cards" style={{ borderRadius: '15px' }}>
          <div className="analytics">
            <h2 className="mn_hdng">Ad Performance</h2>
          </div>
          <LineChart data={graphPerformance} />
        </Item>
        <Item className="cards" style={{ borderRadius: '15px' }}>
          <div className="analytics">
            <h2 className="mn_hdng">Transactions and Payments</h2>
          </div>

          <LineChart data={graphStoreData} />
        </Item>
      </div>
    </MainContainer>
  );
};

export default Analytics;
